import env from './env'

export const CODE_QUERY_PARAM = 'oobCode'

export const MODE_QUERY_PARAM = 'mode'

export const CONTINUE_URL_QUERY_PARAM = 'continueUrl'

export const REAUTHENTICATE_QUERY_PARAM = 'reauthenticate'

export const SECURITY_QUERY_PARAM = 'changePassword'

export const DELETE_ACCOUNT_QUERY_PARAM = 'deleteAccount'

export const REAUTHENTICATION_STATUS_QUERY_PARAM = 'reauthenticationStatus'

export const REAUTHENTICATION_VARIANT_QUERY_PARAM = 'reauthenticationVariant'

export const EMAIL_FOR_SIGN_IN_STORAGE_KEY = 'emailForSignIn'

export const VIEWER_MODE_STORAGE_KEY = 'viewerMode'

export const PENDING_TWO_FACTOR_ACTION_STORAGE_KEY = 'pendingTwoFactorAction'

// Names of the 2FA factor saved in the user's Firebase account. Firebase may show
// them to the user. They differ by app, as the name is the only way to tell later
// which app the factor was added in.
export const BLUEBOLT_TOTP_FACTOR_DISPLAY_NAME = 'Blue Bolt Authenticator'

export const GLOBALWORTH_TOTP_FACTOR_DISPLAY_NAME =
  'Globalworth App Authenticator'

// App names shown next to the 2FA code in the authenticator app
export const BLUEBOLT_TOTP_ISSUER = 'BlueBolt'

export const GLOBALWORTH_TOTP_ISSUER = 'GlobalworthApp'

export const SUPER_ADMIN_SESSION_MAX_SECONDS = env.superAdminSessionMaxSeconds

export const SUPER_ADMIN_SESSION_MAX_MS = SUPER_ADMIN_SESSION_MAX_SECONDS * 1000
